/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { ContactFilter, ContactFilterFromJSON, ContactFilterFromJSONTyped, ContactFilterToJSON } from './ContactFilter'

/**
 *
 * @export
 * @interface GetContactFilterResponseData
 */
export interface GetContactFilterResponseData {
  /**
   *
   * @type {ContactFilter}
   * @memberof GetContactFilterResponseData
   */
  filter?: ContactFilter
}

export function GetContactFilterResponseDataFromJSON(json: any): GetContactFilterResponseData {
  return GetContactFilterResponseDataFromJSONTyped(json, false)
}

export function GetContactFilterResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetContactFilterResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    filter: !exists(json, 'filter') ? undefined : ContactFilterFromJSON(json['filter'])
  }
}

export function GetContactFilterResponseDataToJSON(value?: GetContactFilterResponseData | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    filter: ContactFilterToJSON(value.filter)
  }
}
